'use client'

import { type CustomerReviewsProps } from '@src/components/CustomerReviews/CustomerReviews.props'

export const CustomerReviewsDefaults: CustomerReviewsProps = {
  gradientColor: '#F2FEE7',
  accentColor: '#208468',
  blocksBottom: [
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      component: {
        name: 'Text',
        options: {
          text: '<p> How Our Customer Ratings Work: This Rating is an average of individual rating responses collected by BODi from 23 regular Energize subscription customers.</p>',
          getValueFromCountdown: false,
          style: 'Body SM',
          actionName: 'none',
          navigate: { href: '/', analyticsEvent: 'none' },
        },
      },
      responsiveStyles: { large: { height: 'auto', textAlign: 'center' } },
    },
  ] as any,
  heading: 'Customer Reviews',
  subheading: '<strong>4.9 RATING</strong>',
  loadMoreText: 'Load more',
  subHeadingRatingOutOfFive: 5,
  items: [
    {
      name: 'Andrew T.',
      product: 'Energize Pre-Workout - <strong>Fruit Punch</strong/>',
      ratingOutOfFive: 4,
      content: `
        <strong>Lorem ipsum dolor sit amet</strong>
        <br />
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
      `,
    },
    {
      name: 'Sara S.',
      product: 'Energize Pre-Workout - <strong>Fruit Punch</strong/>',
      ratingOutOfFive: 5,
      content: `
        <strong>Lorem ipsum dolor sit amet</strong>
        <br />
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p>
        <br />
        <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
      `,
    },
    {
      name: 'Kelly E.',
      product: 'Energize Pre-Workout - <strong>Fruit Punch</strong/>',
      ratingOutOfFive: 3.5,
      content: `
        <strong>Lorem ipsum dolor sit amet</strong>
        <br />
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
        <br />
        <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
      `,
    },
    {
      name: 'Devin S.',
      product: 'Energize Pre-Workout - <strong>Fruit Punch</strong/>',
      ratingOutOfFive: 3,
      content: `
        <strong>Lorem ipsum dolor sit amet</strong>
        <br />
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
      `,
    },
    {
      name: 'Justin M.',
      product: 'Energize Pre-Workout - <strong>Fruit Punch</strong/>',
      ratingOutOfFive: 3.5,
      content: `
        <strong>Lorem ipsum dolor sit amet</strong>
        <br />
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        <br />
        <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris</p>
      `,
    },
    {
      name: 'Dre I.',
      product: 'Energize Pre-Workout - <strong>Fruit Punch</strong/>',
      ratingOutOfFive: 3.5,
      content: `
        <strong>Lorem ipsum dolor sit amet</strong>
        <br />
        <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
      `,
    },
    {
      name: 'Kelly E.',
      product: 'Energize Pre-Workout - <strong>Fruit Punch</strong/>',
      ratingOutOfFive: 3.5,
      content: `
        <strong>Lorem ipsum dolor sit amet</strong>
        <br />
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
        <br />
        <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
      `,
    },
    {
      name: 'Sara S.',
      product: 'Energize Pre-Workout - <strong>Fruit Punch</strong/>',
      ratingOutOfFive: 5,
      content: `
        <strong>Lorem ipsum dolor sit amet</strong>
        <br />
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p>
        <br />
        <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
      `,
    },
    {
      name: 'Andrew T.',
      product: 'Energize Pre-Workout - <strong>Fruit Punch</strong/>',
      ratingOutOfFive: 4,
      content: `
        <strong>Lorem ipsum dolor sit amet</strong>
        <br />
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
      `,
    },
    {
      name: 'Andrew T.',
      product: 'Energize Pre-Workout - <strong>Fruit Punch</strong/>',
      ratingOutOfFive: 4,
      content: `
        <strong>Lorem ipsum dolor sit amet</strong>
        <br />
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
      `,
    },
    {
      name: 'Justin M.',
      product: 'Energize Pre-Workout - <strong>Fruit Punch</strong/>',
      ratingOutOfFive: 3.5,
      content: `
        <strong>Lorem ipsum dolor sit amet</strong>
        <br />
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        <br />
        <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris</p>
      `,
    },
    {
      name: 'Sara S.',
      product: 'Energize Pre-Workout - <strong>Fruit Punch</strong/>',
      ratingOutOfFive: 5,
      content: `
        <strong>Lorem ipsum dolor sit amet</strong>
        <br />
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p>
        <br />
        <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
      `,
    },
  ],
}
